module.exports = "<div class='js-popout-wrapper'></div>\n";